import { ThemeName } from '~/types'

export const CHANGE_LOCALE = 'CHANGE_LOCALE'

export const changeLocale = (theme: ThemeName) => ({
  type: CHANGE_LOCALE,
  payload: theme,
})
